// extracted by mini-css-extract-plugin
export default {"container":"EmptyTable_container__fnpSC"};